import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, CheckboxComponent, MbsSize, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { RecoveryCodeComponent } from 'mbs-ui-shared@components';

@Component({
  selector: 'mbs-recovery-code-modal',
  templateUrl: './recovery-code-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    RecoveryCodeComponent,
    FormsModule,
    CheckboxComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class RecoveryCodeModalComponent {
  public codes: Array<string>;
  public isSavedRecoveryCodes = false;

  public MbsSize = MbsSize;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
}
